import { useEffect, useState } from 'react';
import { apiClient } from '../lib/api';
import type { SchoolDisclosure } from '../lib/schoolOverview';

export function useSchoolDisclosure(officeCode: string, schoolCode: string) {
  const key = `${officeCode}:${schoolCode}`;
  const [result, setResult] = useState<{ key: string; data: SchoolDisclosure | null; error: boolean } | null>(null);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (!officeCode || !schoolCode) return;
    const controller = new AbortController();
    setResult(null);
    apiClient.getSchoolDisclosure(officeCode, schoolCode, controller.signal)
      .then((data) => { if (!controller.signal.aborted) setResult({ key, data, error: false }); })
      .catch(() => { if (!controller.signal.aborted) setResult({ key, data: null, error: true }); });
    return () => controller.abort();
  }, [officeCode, schoolCode, key, retry]);
  const current = result?.key === key ? result : null;
  return {
    data: current?.data ?? null,
    error: current?.error ?? false,
    loading: Boolean(officeCode && schoolCode && !current),
    retry: () => setRetry((count) => count + 1),
  };
}
